// eslint-disable-next-line @typescript-eslint/naming-convention
export enum EmailDomainType {
  Disposable = 'Disposable',
  Lightricks = 'lightricks',
  Private = 'Private',
  Other = 'Other',
  Business = 'Business',
}

// Disposable domains list
const DISPOSABLE_DOMAINS = new Set([
  'kuandika.com',
  'gufutu.com',
  'rykone.com',
  'numerobo.com',
  'eluxeer.com',
  'bmixr.com',
  'ahaks.com',
  'andinews.com',
  'letterguard.net',
  'pegven.com',
  'zecodo.com',
  'mlln.net',
  'exitbit.com',
  'iridales.com',
  'ofacer.com',
  'decodewp.com',
  'coasah.com',
  'kimdyn.com',
  'asimarif.com',
  'boxmach.com',
  'feelingity.com',
  'purmuttad.com',
  'quikmobi.com',
  'pamvest.com',
  'xkxkud.com',
  'qumisw.com',
  'aminating.com',
  'forexzig.com',
  '2925.com',
  'rizerco.com',
  'fameincstudent.org',
  'fxzig.com',
  'ornadar.com',
  'jioso.com',
  'letterprotect.net',
]);

const PRIVATE_LIKE = /(mail|yahoo\.|outlook\.|live\.|gmx\.|bigpond\.)/;

// Private (free email) domains list
const PRIVATE_DOMAINS = new Set([
  'gmail.com',
  'icloud.com',
  'outlook.com',
  'yahoo.com',
  '163.com',
  'qq.com',
  '126.com',
  'protonmail.com',
  'mail.ru',
  'yandex.ru',
  'gmx.com',
  'zoho.com',
  'aol.com',
  'mail.com',
  'fastmail.com',
  'tutanota.com',
  'rediffmail.com',
  'web.de',
  'libero.it',
  'sina.com',
  'sohu.com',
  'comcast.net',
  'live.com',
  'proton.me',
  'hotmail.com',
  'orange.fr',
  'free.fr',
  'btinternet.com',
  'verizon.net',
  'me.com',
  'naver.com',
  'daum.net',
  'bigpond.com',
  'telus.net',
  'shaw.ca',
  'rogers.com',
  'charter.net',
  'optonline.net',
  'earthlink.net',
  'sky.com',
  'talktalk.net',
  'virginmedia.com',
  'blueyonder.co.uk',
  'o2.co.uk',
  'wanadoo.fr',
  'laposte.net',
  'tiscali.co.uk',
  'alice.it',
  'tin.it',
  'virgilio.it',
  'seznam.cz',
  'centrum.cz',
  'gmx.de',
  'web.de',
  'orange.fr',
  'free.fr',
  'laposte.net',
  'libero.it',
  'tiscali.it',
  'alice.it',
  'tin.it',
  'virgilio.it',
  'terra.es',
  'telefonica.net',
  'kpnmail.nl',
  'seznam.cz',
  'centrum.cz',
  '163.com',
  '126.com',
  'yeah.net',
  'qq.com',
  'sina.com',
  'sohu.com',
  'yahoo.co.jp',
  'docomo.ne.jp',
  'ezweb.ne.jp',
  'softbank.ne.jp',
  'naver.com',
  'daum.net',
  'rediffmail.com',
  'comcast.net',
  'verizon.net',
  'charter.net',
  'msn.com',
  'optonline.net',
  'shaw.ca',
  'rogers.com',
  'telus.net',
  'bol.com.br',
  'terra.com.br',
  'fibertel.com.ar',
  'bigpond.com',
  'iinet.net.au',
  'xtra.co.nz',
  'googlemail.com',
  'hotmail.co.uk',
]);

function getEmailDomainType(emailOrEmailDomain: string): EmailDomainType {
  const domain = emailOrEmailDomain.includes('@')
    ? emailOrEmailDomain.split('@')[1]?.toLowerCase() || ''
    : emailOrEmailDomain.toLowerCase();

  // 1. Disposable check
  if (DISPOSABLE_DOMAINS.has(domain)) {
    return EmailDomainType.Disposable;
  }

  // 2. Lightricks check
  if (/lightricks\./.test(domain)) {
    return EmailDomainType.Lightricks;
  }

  // 3. Private email providers
  if (PRIVATE_LIKE.test(domain) || PRIVATE_DOMAINS.has(domain)) {
    return EmailDomainType.Private;
  }

  // 4. EDU/AC/GOV/MIL/ORG check
  if (/\.(edu|ac|gov|mil|org)(\.|$)/.test(domain)) {
    return EmailDomainType.Other;
  }

  // 5. Default
  return EmailDomainType.Business;
}

export default getEmailDomainType;
